module.exports = __webpack_public_path__ + "static/media/icon-event__la-guerra-fria-hover.40661320.svg";